<svelte:options immutable={true} />

<script>import Icon from 'svelte-awesome';
import { faRotate } from '@fortawesome/free-solid-svg-icons';
export let count;
export let maxSampleCount;
export let onRefresh;
</script>

<button
  type="button"
  class="jse-column-header"
  title={`The Columns are created by sampling ${maxSampleCount} items out of ${count}. ` +
    "If you're missing a column, click here to sample all of the items instead of a subset. " +
    'This is slower.'}
  on:click={() => onRefresh()}
>
  <Icon data={faRotate} />
</button>

<style src="./RefreshColumnHeader.scss">.jse-column-header {
  background: none;
  border: none;
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  display: flex;
  gap: var(--jse-padding);
  padding: calc(0.5 * var(--jse-padding)) var(--jse-padding) calc(0.5 * var(--jse-padding)) calc(0.5 * var(--jse-padding));
  width: 100%;
}
.jse-column-header:hover {
  background: var(--jse-table-header-background-highlight);
}
.jse-column-header:not(.jse-column-header.jse-readonly) {
  cursor: pointer;
}</style>
